export default ({ request }) => ({

  infoDocListApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoDoc/list',
      method: 'post',
      data
    })
  },
  infoDocSaveApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoDoc/save',
      method: 'post',
      data
    })
  },
  infoDocDelApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoDoc/del',
      method: 'post',
      data
    })
  },
  infoDocDetailApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoDoc/detail',
      method: 'post',
      data
    })
  },
  infoDocEditApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoDoc/edit',
      method: 'post',
      data
    })
  }
})
